import * as React from 'react';
import reject from 'lodash.reject';
import {DataIteratorProps, DataIteratorRenderItemProps, DataIteratorRenderSelectionBarProps} from './types';

// TODO: add virtualized list feature
export default class DataIterator<T> extends React.Component<DataIteratorProps<T>, {}> {
  public render() {
    const {rootComponent: Root = 'div', onSelectionChange, ...restProps} = this.props;

    return (
      <Root {...restProps}>
        {this._renderHeader()}
        {this._renderContents()}
        {this._renderFooter()}
      </Root>
    );
  }

  private _renderContents() {
    const {
      items,
      selection,
      onSelectionChange,
      renderItem,
      contentsProps,
      contentsWrapperComponent: ContentsWrapper = 'div'
    } = this.props;

    const contents = items.map((currentItem: T, index: number) => {
      const handleSelectToggle = (selected: boolean) =>
        onSelectionChange(selected ? [currentItem, ...selection] : reject(selection, currentItem));

      const props: DataIteratorRenderItemProps<T> = {
        item: currentItem,
        selected: selection.indexOf(currentItem) > -1,
        handleSelectToggle
      };
      return <React.Fragment key={index}>{renderItem(props)}</React.Fragment>;
    });

    return <ContentsWrapper {...contentsProps}>{contents}</ContentsWrapper>;
  }

  private _renderHeader() {
    const {header} = this.props;
    return typeof header === 'function' ? header(this._selectionBarProps) : header;
  }

  private _renderFooter() {
    const {footer} = this.props;
    return typeof footer === 'function' ? footer(this._selectionBarProps) : footer;
  }

  private get _selectionBarProps(): DataIteratorRenderSelectionBarProps {
    const {
      _handleSelectAllToggle: handleSelectAllToggle,
      _itemsCount: itemsCount,
      _selectedItemsCount: selectedItemsCount
    } = this;

    return {
      handleSelectAllToggle,
      itemsCount,
      selectedItemsCount,
      partiallySelected: selectedItemsCount > 0 && selectedItemsCount < itemsCount,
      allSelected: selectedItemsCount === itemsCount
    };
  }

  private _handleSelectAllToggle = (selected: boolean) => {
    const {items, onSelectionChange} = this.props;
    onSelectionChange(selected ? items : []);
  };

  private get _itemsCount() {
    return this.props.items.length;
  }

  private get _selectedItemsCount() {
    return this.props.selection.length;
  }
}



// WEBPACK FOOTER //
// ./src/components/DataIterator/DataIterator.tsx